import { render, staticRenderFns } from "./CategoryItems.vue?vue&type=template&id=563a2fa6&scoped=true&"
import script from "./CategoryItems.vue?vue&type=script&lang=js&"
export * from "./CategoryItems.vue?vue&type=script&lang=js&"
import style0 from "./CategoryItems.vue?vue&type=style&index=0&id=563a2fa6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563a2fa6",
  null
  
)

export default component.exports